'use strict';

module.exports = require('./AutosuggestContainer').default;


/*****************
 ** WEBPACK FOOTER
 ** /Users/kylemathews/programs/typography.js/packages/typography-design-tools/~/react-autosuggest/dist/index.js
 ** module id = 496
 ** module chunks = 0
 **/